import { render, staticRenderFns } from "./RecepcionFacturaMiniDetalleComponent.vue?vue&type=template&id=4fb0f991&scoped=true&"
import script from "./RecepcionFacturaMiniDetalleComponent.vue?vue&type=script&lang=js&"
export * from "./RecepcionFacturaMiniDetalleComponent.vue?vue&type=script&lang=js&"
import style0 from "./RecepcionFacturaMiniDetalleComponent.vue?vue&type=style&index=0&id=4fb0f991&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb0f991",
  null
  
)

export default component.exports